import styled from 'styled-components';
import { FunctionComponent } from 'react';
import { PersonIcon, ThreeBarsIcon } from '@primer/octicons-react';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';
import { useAppDispatch } from '../../redux/hooks';
import { showMenu } from '../../redux/slices/modal.slice';

// Outline pill on wide screens, round menu button on narrow ones, as in
// the cozyjuicyreal.com header.
const Panel = styled('button')<{ $round: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  height: 40px;
  width: ${({ $round }) => ($round ? '40px' : 'auto')};
  padding: ${({ $round }) => ($round ? '0' : '0 16px')};
  border: 1px solid var(--border);
  border-radius: 9999px;
  background: var(--background);
  color: var(--foreground);
  font: 500 14px var(--font-body);
  cursor: pointer;
  transition: color 150ms, background-color 150ms;

  &:hover {
    color: var(--primary);
    background: var(--secondary);
  }
`;

export const CHANGE_MENU_WIDTH = 1040;

export const AccountMenu: FunctionComponent = () => {
  const { width } = useWindowDimensions();
  const dispatch = useAppDispatch();
  const isWide = width > CHANGE_MENU_WIDTH;

  return (
    <Panel
      $round={!isWide}
      aria-label={isWide ? undefined : 'Open menu'}
      onClick={() => dispatch(showMenu())}
      type="button"
    >
      {isWide ? (
        <>
          <PersonIcon size={16} />
          Account
        </>
      ) : (
        <ThreeBarsIcon size={20} />
      )}
    </Panel>
  );
};
